/* Almla redesign: Grip Cloud early-access screen (snippets/alm-gc-gate.liquid).
   Counts down to early access (9:00 AM PT) and then to the public launch
   (12:00 PM PT), reloading at each so Locksmith decides what shows. The
   password goes through Locksmith's own prompt, kept in .pw-ls: our field
   fills its field and submits its form, and its error comes back as ours. */
(function () {
  var pw = document.querySelector("[data-gc-gate]");
  if (!pw) return;
  document.body.classList.add("alm-gated");
  var EA = Date.parse(pw.getAttribute("data-ea")), PUB = Date.parse(pw.getAttribute("data-pub"));
  var $ = function (s) { return pw.querySelector(s); };
  var two = function (n) { return String(n).padStart(2, "0"); };
  var reloadAt = null;

  function state(now) { return now < EA ? "early" : "open"; }

  function tick() {
    var now = Date.now(), st = state(now);
    pw.setAttribute("data-live", st);
    [].forEach.call(pw.querySelectorAll(".pw-st"), function (e) { e.hidden = e.getAttribute("data-st") !== st; });
    var target = st === "early" ? EA : PUB;
    var s = Math.max(0, Math.floor((target - now) / 1000)), d = Math.floor(s / 86400);
    $(".pw-d").textContent = two(d); $(".pw-dd").hidden = d === 0;
    $(".pw-h").textContent = two(Math.floor(s % 86400 / 3600));
    $(".pw-m").textContent = two(Math.floor(s % 3600 / 60));
    $(".pw-s").textContent = two(s % 60);
    /* At 9:00 and 12:00 PT, reload (a few seconds late, after Locksmith's own switch). */
    if (s === 0 && reloadAt === null) {
      reloadAt = setTimeout(function () { location.reload(); }, 5000 + Math.random() * 10000);
    }
  }
  tick(); setInterval(tick, 1000);

  var f = $(".pw-form"), i = f.querySelector("input"), m = $(".pw-msg"), b = f.querySelector("button");
  var ls = $(".pw-ls");
  function fail(text) {
    m.textContent = text;
    i.setAttribute("aria-invalid", "true"); f.classList.add("is-err");
    b.disabled = false; i.select();
  }
  function lsField() {
    return ls && ls.querySelector('input[type="password"], input[name="passcode"], input[name*="passcode"], input[type="text"]');
  }

  f.addEventListener("submit", function (e) {
    e.preventDefault();
    /* The early-access password is all capitals; accept it however it's typed. */
    var code = i.value.trim().toUpperCase();
    if (!code) { fail("Enter the password from your early-access email."); return; }
    if (state(Date.now()) === "early") { fail("Early access opens at 9:00 AM PST. See you then!"); return; }
    var tries = 0;
    (function go() {
      var field = lsField();
      if (!field) {
        if (++tries > 40) { fail("Something went wrong. Refresh the page and try again."); return; }
        return setTimeout(go, 150);
      }
      b.disabled = true; m.textContent = "";
      var form = field.form;
      field.value = code;
      field.dispatchEvent(new Event("input", { bubbles: true }));
      /* Watch Locksmith's own requests: a right password is followed by a cart
         update (the saved key) and a reload; a wrong one by nothing. */
      var settled = false;
      function wrong() { if (!settled) { settled = true; fail("That password didn't work. Check your early-access email."); } }
      if (!window.__gcFetch) {
        window.__gcFetch = window.fetch;
        window.fetch = function (url) {
          var u = String(url && url.url || url);
          var p = window.__gcFetch.apply(this, arguments);
          if (u.indexOf("/cart/update") > -1) window.__gcKey = true;
          if (u.indexOf("/apps/locksmith/resource") > -1) {
            p.then(function () {
              setTimeout(function () { if (!window.__gcKey && window.__gcWrong) window.__gcWrong(); }, 1500);
            }, function () { if (window.__gcWrong) window.__gcWrong(); });
          }
          return p;
        };
      }
      window.__gcKey = false;
      window.__gcWrong = wrong;
      if (form && form.requestSubmit) form.requestSubmit();
      else if (form) {
        var sb = form.querySelector('[type="submit"], button');
        if (sb) sb.click(); else form.submit();
      }
      setTimeout(function () { if (!window.__gcKey) wrong(); }, 15000);
    })();
  });
  i.addEventListener("input", function () {
    f.classList.remove("is-err"); i.removeAttribute("aria-invalid"); m.textContent = "";
  });
})();
